module.exports = {"230712001":"河南街道","230712002":"河北街道","230712400":"日新林场","230712401":"石林林场","230712402":"东升林场","230712403":"二龙山林场","230712404":"高峰林场","230712405":"二清河林场","230712406":"守虎山林场","230712407":"泉石林场","230712408":"峻岭林场","230712409":"育林经营所","230712410":"团结经营所","230712411":"磨石山经营所","230712412":"中心苗卜","230712413":"克林经营所"}


//////////////////
// WEBPACK FOOTER
// ./src/town/230712.json
// module id = 693
// module chunks = 0